import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AccountService, BillingService, CollectionsService } from '@core/services';
import { ChangableComponent } from '@models/changable.component';
import { LibraryRouter } from '@models/library.router';
import { addYears } from 'date-fns';
import { Collection, CollectionLicenseEnum } from 'lingo2-models';

@Component({
  selector: 'app-collection-meta',
  templateUrl: './collection-meta.component.html',
  styleUrls: ['./collection-meta.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CollectionMetaComponent extends ChangableComponent implements OnChanges {
  @Input() collection: Collection;

  public collectionUrl: string;
  public authorUrl: string;
  public price_tier_personal: number;
  public price_tier_professional: number;
  public price_tier_business: number;
  public price_valid_until: Date;
  public fullTitle: string;
  public metaImageUrl: string;
  private collectionRoute = LibraryRouter.collectionRouteUniversal;

  constructor(
    private collectionsService: CollectionsService,
    private billingService: BillingService,
    protected readonly cdr: ChangeDetectorRef,
  ) {
    super(cdr);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.collection) {
      this.prepareMeta();
    }
  }

  private prepareMeta() {
    this.fullTitle = this.collectionsService.collectionFullTitle(this.collection).slice(0, 100);
    this.collectionUrl = this.collectionRoute(this.collection);
    this.authorUrl = AccountService.accountRoute(this.collection.author).join('/');
    if (this.collection?.price_tiers) {
      this.price_tier_personal = this.collection?.price_tiers[CollectionLicenseEnum.personal];
      this.price_tier_professional = this.collection?.price_tiers[CollectionLicenseEnum.professional];
      this.price_tier_business = this.collection?.price_tiers[CollectionLicenseEnum.business];
    }
    this.price_valid_until = addYears(new Date(), 5);
    this.prepareMetaImage();
    this.markForCheck();
  }

  protected prepareMetaImage() {
    let _cover = this.collection.cover;

    let metaImage = _cover?.lgX2 || _cover?.lg || _cover?.mdX2 || _cover?.md;
    if (!metaImage && this.collection.multi_cover?.length) {
      _cover = this.collection.multi_cover[0];
      metaImage = _cover?.lgX2 || _cover?.lg || _cover?.mdX2 || _cover?.md;
    }

    this.metaImageUrl = metaImage?.url;
  }
}
